import { render, staticRenderFns } from "./CustomDatabaseSettings.vue?vue&type=template&id=17066202&scoped=true&"
import script from "./CustomDatabaseSettings.vue?vue&type=script&lang=js&"
export * from "./CustomDatabaseSettings.vue?vue&type=script&lang=js&"
import style0 from "./CustomDatabaseSettings.vue?vue&type=style&index=0&id=17066202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17066202",
  null
  
)

export default component.exports